import {GetUserInfoLogic, GetRatingDelivery, GetShopsLogic, GetPhotoProfileLogic} from "../Application/GetUserInfo.logic";
import { DeleteUserLogic, ConfirmSignUpCodeLogic} from "../Application/UserRegister.logic";

export async function GetUserInfo(id) {
  const infoUser = await GetUserInfoLogic(id);
  return infoUser;
}

export async function DeleteUser(data) {
  return DeleteUserLogic(data);
}

export async function GetRating(id) {
  return GetRatingDelivery(id);
}

export async function GetShops(data){
  return GetShopsLogic(data);
}

export async function GetPhotoProfile(urlPhoto){
  const res = await GetPhotoProfileLogic(urlPhoto);
  return res;
}

export async function ConfirmSignUpCode({id, code, data}){
  return ConfirmSignUpCodeLogic({id,code, data});
}
